var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Functies importeren")]),
      _c("w-data-table", {
        staticStyle: { "flex-grow": "1", height: "calc(100vh - 185px)" },
        attrs: {
          items: _vm.scripts,
          columns: _vm.columns,
          "selected-items": _vm.selectedItems,
        },
      }),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: _vm.selectedItems.length == 0 },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v("Bevestigen")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }